import {
  // createAction,
  handleActions
} from "redux-actions";
import {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_NEW_MEMBERSHIPS_SUCCESS,
  FETCH_NEW_MEMBERSHIPS_EXPIRING_SUCCESS,
  FETCH_EXPIRED_MEMBERSHIPS_SUCCESS,
  FETCH_MEMBERSHIPS_SOLD_SUCCESS,
  FETCH_MEMBERS_AT_RISK_SUCCESS,
  FETCH_TOTAL_ACTIVE_MEMBERS_SUCCESS,
  FETCH_ZERO_VISITS_MEMBERS_SUCCESS,
  FETCH_YEAR_OVER_YEAR_MEMBERSHIP_REVENUE_SUCCESS,
  FETCH_FROZEN_MEMBERS_SUCCESS
} from "../sagas/membership/membership";
// Name Spaced Action Types
export const actions = {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_NEW_MEMBERSHIPS_SUCCESS,
  FETCH_NEW_MEMBERSHIPS_EXPIRING_SUCCESS,
  FETCH_EXPIRED_MEMBERSHIPS_SUCCESS,
  FETCH_MEMBERSHIPS_SOLD_SUCCESS,
  FETCH_MEMBERS_AT_RISK_SUCCESS,
  FETCH_TOTAL_ACTIVE_MEMBERS_SUCCESS,
  FETCH_ZERO_VISITS_MEMBERS_SUCCESS,
  FETCH_YEAR_OVER_YEAR_MEMBERSHIP_REVENUE_SUCCESS,
  FETCH_FROZEN_MEMBERS_SUCCESS
};

// createAction is a lib for creating FSAs
// see https://github.com/acdlite/flux-standard-action, for info in the flux standard action
export const actionCreators = {};

export const initialState = {
  currentUser: {},
  currencySymbol: "",
  isPayingMembers: false,
  payingMembersNumber: {},
  newMemberships: {},
  membershipSales: {},
  membersAtRisk: {
    membersAtRiskNumber: 0
  },
  frozenMembers: {
    totalFrozen: {}
  },
  totalMembersNumber: {},
  zeroVisitMembers: {},
  yearOverYearMembershipRevenue: [],
  isLoading: true
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser
    }),
    [FETCH_NEW_MEMBERSHIPS_SUCCESS]: (state, action) => ({
      ...state,
      newMemberships: action.payload.newMemberships || state.newMemberships
    }),
    [FETCH_NEW_MEMBERSHIPS_EXPIRING_SUCCESS]: (state, action) => ({
      ...state,
      membershipsExperingSoon: action.payload.membershipsExperingSoon || state.membershipsExperingSoon
    }),
    [FETCH_EXPIRED_MEMBERSHIPS_SUCCESS]: (state, action) => ({
      ...state,
      expiredMemberships: action.payload.expiredMemberships || state.expiredMemberships
    }),
    [FETCH_MEMBERSHIPS_SOLD_SUCCESS]: (state, action) => ({
      ...state,
      membershipSales: action.payload.membershipSales || state.membershipSales,
      currencySymbol: action.payload.currencySymbol || state.currencySymbol
    }),
    [FETCH_TOTAL_ACTIVE_MEMBERS_SUCCESS]: (state, action) => ({
      ...state,
      isPayingMembers: action.payload.isPayingMembers,
      payingMembersNumber: action.payload.payingMembersNumber || state.payingMembersNumber,
      totalMembersNumber: action.payload.totalMembersNumber || state.totalMembersNumber
    }),
    [FETCH_ZERO_VISITS_MEMBERS_SUCCESS]: (state, action) => ({
      ...state,
      zeroVisitMembers: action.payload.zeroVisitMembers || state.zeroVisitMembers
    }),
    [FETCH_FROZEN_MEMBERS_SUCCESS]: (state, action) => ({
      ...state,
      frozenMembers: action.payload
    }),
    [FETCH_YEAR_OVER_YEAR_MEMBERSHIP_REVENUE_SUCCESS]: (state, action) => ({
      ...state,
      yearOverYearMembershipRevenue: action.payload || state.yearOverYearMembershipRevenue
    }),
    [FETCH_MEMBERS_AT_RISK_SUCCESS]: (state, action) => ({
      ...state,
      membersAtRisk: action.payload || state.membersAtRisk
    })
  },
  initialState
);
